import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { numberFormat, percentFormat } from "@/shared/utils/common";
import type { Analytics } from "@models/analytics.model";
import StatisticsCard from "./StatisticsCard";

export default function PerformanceLaunchInsights({ analytics }: { analytics: Analytics }) {
    const charts = analytics.charts;

    // MPN-1142: server hides the tile for non-PFR deals via `applicable`
    // (always true for now — see PFR_GATE / MPN-1184).
    const showInvestment = charts["est-investment"]?.applicable !== false;

    return (
        <div className={`client-dashboard__kpi-grid${showInvestment ? " client-dashboard__kpi-grid--3" : ""}`}>
            <StatisticsCard
                title="Total Engagements"
                value={numberFormat(charts["eng-count"]?.engagement_count ?? 0)}
                icon={<i className="bi bi-people-fill" />}
            />
            {/* No tooltip behind the percentage (MPN-1770). It showed the two raw numbers,
                which invited the reader to check the division and then to ask why the
                denominator was the whole list rather than the group we were allowed to
                reach. The division is right now, and a client dashboard is not the place to
                show somebody the working. */}
            <StatisticsCard
                title="Conversion Rate"
                value={`${percentFormat(charts["conv-rate"]?.conv_rate ?? 0)}%`}
                icon={<i className="bi bi-percent" />}
            />
            {/*
              Estimated Revenue & Estimated ROI hidden for now (MPN-1084): they read
              $0 / 0% until revenue data lands. To restore, re-add the two
              StatisticsCards here and revert .client-dashboard__kpi-grid back to
              grid-template-columns: repeat(4, 1fr).
            */}
            {showInvestment && (
                <StatisticsCard
                    title="Estimated Investment"
                    value={`$${numberFormat(charts["est-investment"]?.total ?? 0)}`}
                    icon={
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>Total spend to date</Tooltip>}
                        >
                            <i className="bi bi-wallet2" />
                        </OverlayTrigger>
                    }
                />
            )}
        </div>
    );
}
